export const PASSPORT_ERROR_MESSAGES = {
  passportIsEmpty: "Заполните поле",
  passportIsTooShort: "Введите верный номер документа",
  default: "Введите корректный номер документа",
  unexpectedServerError: "Ошибка при проверке данных, попробуйте позже",
};

/**
 * Removes all spaces from the passport input string.
 */
export const clearPassport = (passport: string): string => passport.replace(/\s+/g, "");
